import { useEffect, useState } from 'react';
import { NavigateFunction, useNavigate } from 'react-router-dom';
import { FilterField, FilterForm } from '../../../../../components/tables/filterForms/FilterForm';
import { FormSelect } from '../../../../../components/tables/filterForms/FormSelect';
import SFCTable from '../../../../../components/tables/SFCTable';
import { useToast } from '../../../../../context/ToastContext';
import { useListFiltersInUrl } from '../../../../../hooks';
import { User, Waiver } from '../../../../../services/endpoints/people/user';
import { useGetAllWaiversQuery } from '../../../../../services/endpoints/people/waiver';
import { useGetCoursesSimpleQuery } from '../../../../../services/endpoints/schedule/course';
import { getCurrentUser } from '../../../../../services/helper';
import { waiverColumns } from '../../../../../utils/consts/columnDefs/waiverColumns';
import { getFilterValue } from '../../../../../utils/listFilterSearchParams';

const defaultScope = '';
const currentUser = getCurrentUser();

export const userCanEditCreateDelete_Waviers = (user: User | null) => {
  if (user?.isSuper || user?.isSupremeAdmin) {
    return true;
  }

  return false;
};

export const userCanView_Waviers = (user: User | null) => {
  if (user?.isSuper || user?.isSupremeAdmin) {
    return true;
  }
  return false;
};

export const WaiversView = () => {
  const { addToast } = useToast();
  const [filters, setFilters] = useListFiltersInUrl({
    scope: defaultScope,
    data: { page: 1, entries: 10 }
  });
  const { data, error, isLoading, isFetching } = useGetAllWaiversQuery(filters);
  const {
    data: courses,
    error: coursesError,
    isLoading: coursesLoading
  } = useGetCoursesSimpleQuery();
  const [waivers, setWaivers] = useState<Waiver[]>([]);
  const navigate: NavigateFunction = useNavigate();
  const isGlobalUser = currentUser?.isGlobal;

  const filterFormFields: FilterField[] = [
    {
      name: 'course_id',
      type: 'number',
      element: (
        <FormSelect
          name="course_id"
          label="Session"
          options={courses?.results.map((c) => ({ value: c.id, label: c.title })) ?? []}
          selected_Value={courses?.results
            .map((c) => ({ value: c.id, label: c.title }))
            .find((option) => String(option.value) === getFilterValue(filters.data?.filterBy, 'course_id'))}
        />
      )
    },
    {
      name: 'child_first_name',
      label: 'Child First Name',
      value: getFilterValue(filters.data?.filterBy, 'child_first_name')
    },
    {
      name: 'child_last_name',
      label: 'Child Last Name',
      value: getFilterValue(filters.data?.filterBy, 'child_last_name')
    },
    {
      name: 'parent_first_name',
      label: 'Parent First Name',
      value: getFilterValue(filters.data?.filterBy, 'parent_first_name')
    },
    {
      name: 'parent_last_name',
      label: 'Parent Last Name',
      value: getFilterValue(filters.data?.filterBy, 'parent_last_name')
    }
  ];

  useEffect(() => {
    if (error) {
      addToast('Error while loading data', 'error');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, error, isLoading]);

  useEffect(() => {
    if (data && data.results) {
      setWaivers(data.results);
    }
  }, [data]);

  const setFilterBy = (filterBy: { operator: string; field: string; value: string }[]) => {
    setFilters((prev) => ({
      ...prev,
      data: {
        ...prev!.data,
        filterBy
      }
    }));
  };

  return (
    <div className="py-2">
      <SFCTable
        name={`Waivers`}
        columns={waiverColumns}
        data={waivers}
        count={data?.count}
        defaultScope={filters.scope ?? defaultScope}
        isLoading={isLoading}
        isFetching={isFetching}
        indexDownloadPath="waivers"
        filters={filters?.data?.filterBy}
        filterForm={
          <FilterForm
            fields={filterFormFields}
            onApplyFilters={setFilterBy}
          />
        }
        onFiltersChanged={setFilters}
      />
    </div>
  );
};
